import { FC, SyntheticEvent, useMemo } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { Autocomplete, TextField } from '@mui/material'

export const FilterCriteriaValueMultiSelect: FC<FilterCriteriaValueFieldProps> = ({
  assumption,
  fieldProps: { value, onChange, error, ...fieldProps },
}) => {
  const handleChange = (_event: SyntheticEvent, newValue: Array<string>) => {
    onChange(newValue.join(','))
  }

  const expandedValue = useMemo(() => (value ? value.split(/\s*,\s*/) : []), [value])

  return (
    <Autocomplete
      multiple
      renderInput={(params) => <TextField variant="outlined" error={error} {...params} />}
      options={assumption.selectOptions!}
      onChange={handleChange}
      value={expandedValue}
      slotProps={{ chip: { size: 'small' } }}
      {...fieldProps}
    />
  )
}
